const replaceIndexAt = (list, item, index) => {
    return [
        ...list.slice(0, index),
        item,
        ...list.slice(index + 1)
    ];
}

const removeIndexAt = (list, index) => {
    list.splice(index, 1);

    return list;
};

const enterLoadingState = (stateUpdater) => {
    stateUpdater((oldState) => {
        const mockState = [...oldState];
        mockState[0] = true;
        return mockState;
    });
};

const exitLoadingState = (stateUpdater) => {
    stateUpdater((oldState) => {
        const mockState = [...oldState];
        mockState[0] = false;
        return mockState;
    });
};

const randomIntInRange = (max) =>  {
    return Math.floor(Math.random() * Math.floor(max));
};

const groupSubItemsByField = (firstField, list, groupFieldList) => {
    return list.reduce((acc, curr) => {
        if(acc.length) {
            const sameItem = acc.find(items => items[firstField] === curr[firstField]);
            if(sameItem) {
                groupFieldList.forEach(field => {
                    sameItem[field] += curr[field];
                })
            }else {
                acc.push(curr);
            }
        } else{
            acc.push(curr);
        }
        return acc;
    }, [])
};

const groupSubItemsByMultiField = (firstField, secondField, list, groupFieldList) => {
    return list.reduce((acc, curr) => {
        if(acc.length) {
            const sameItem = acc.find(items => items[firstField] === curr[firstField] && items[secondField] === curr[secondField]);
            if(sameItem) {
                groupFieldList.forEach(field => {
                    sameItem[field] += curr[field];
                })
            }else {
                acc.push(curr);
            }
        } else{
            acc.push(curr);
        }
        return acc;
    }, [])
};

const createMonthlyDateRange = () => {
    const endDate = new Date();
    const beginDate = new Date();
    beginDate.setMonth(endDate.getMonth() - 1);
    return [beginDate, endDate]
};


export {
    replaceIndexAt,
    randomIntInRange,
    removeIndexAt,
    enterLoadingState,
    exitLoadingState,
    groupSubItemsByField,
    groupSubItemsByMultiField,
    createMonthlyDateRange
}